import TourPackageHttp from "../../tourPackageHttp";

class  CruzeScanServices{

static async getScannedData(){
    return TourPackageHttp.get('/getQrScanData');
}
}
export default CruzeScanServices